import Vue from 'vue'
import Vuex from 'vuex'
 

Vue.prototype.mapState = Vuex.mapState;

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 0,
	showAlert : false,
	showQrCode : false,
	applyformShow : false,
	qrCode : '',
	applyState : false,
	startTime : false,
	endTime : false,
	init : false,
	activityRule : '',
	liked : false,
	userName : '',
	userPortrait : '',
	bannerImg : '',
	price : '', 
	count : '',
	sqrCount : '',
	authed : false,
	userInfo : {},
	uid : '',
	detailId : '',
	try_chou : '',
	site_yhxy : '',
	showShare : false,
	userInfoId : '',
	stage: '',
	allTryList: [],
	tid: -1,
	miniapp: false,
	totalNum: 0,
	applyNum: 0,
	hasCoupon: false,
	couponTitle: '',
	couponImg: '',
	couponUrl: '',
  },
  mutations: {
	setApplyState(state,val){
		state.applyState = val;
	},
    showQrCode (state) {
      state.showQrCode = true;
    },
	hideQrCode (state) {
	  state.showQrCode = false;
	},
	setApplyformShow (state,val) { 
	  state.applyformShow = val;
	},
	setShowAlert (state,val) { 
	  state.showAlert = val;
	},
	setState(state,datas){
		console.log('setState store', datas);
		Object.keys(datas).forEach(function(item){
			state[item] = datas[item];
		})
	},
	init(state,datas){
		console.log('init store');
		console.log(datas);
		Object.keys(datas).forEach(function(item){
			state[item] = datas[item];
		})
		
		state.init = true;
		var nowTime = new Date().getTime();
		if(state.startTime > nowTime){
			state.applyState = 'start';
		}
		
		if(nowTime >= state.startTime){
			state.applyState = 'ing';
		}
		
		if(nowTime >= state.endTime){
			state.applyState = 'end';
		}
		
		//console.log(state.applyState)
		//state = datas;
	}
	
	
  }
})

export default store;